import { BrowserView, MobileView } from "react-device-detect";
import RecitationSubmissionReportMobile from "./recitationSubmissionReportMobile";
import RecitationSubmissionReportWeb from "./recitationSubmissionReportWeb";
import RecitationAbiUmiWeb from "./case-abiumi/recitationAbiUmiWeb";
import RecitationAbiUmiMobile from "./case-abiumi/recitationAbiUmiMobile";
export const RecitationSubmissionReport = () => {
  const company = JSON.parse(localStorage.getItem("company")!);
  return (
    <>
      <MobileView>
        {company && company.id === "60d4278f572103469d7a80dd" ? (
          <RecitationAbiUmiMobile />
        ) : (
          <RecitationSubmissionReportMobile />
        )}
      </MobileView>
      <BrowserView>
        {company && company.id === "60d4278f572103469d7a80dd" ? (
          <RecitationAbiUmiWeb />
        ) : (
          <RecitationSubmissionReportWeb />
        )}
      </BrowserView>
    </>
  );
};
